import React, {
  useState,
  useEffect,
  useMemo,
  useContext,
  Fragment,
} from "react"
import { randomBytes } from "crypto"
import PropTypes from "prop-types"
import ProcessSlideNumbers from "./process-slide-numbers"
import { ThemeContext } from "../contexts/theme-context"

const ProcessSlider = ({ children, lang = "de" }) => {
  const [slide, setSlide] = useState([0, 0])
  const content = require("../data/process.json").processSlide
  const firstSlide = require("../data/process.json").processIntroSlide[lang]
  const theme = useContext(ThemeContext)

  useEffect(() => {
    if (theme[0][0] === "dark") theme[1](["light", "full"])
  }, [theme])

  const renderFirstSlide = useMemo(
    () =>
      firstSlide.map((val, idx) => {
        if (idx !== firstSlide.length - 1)
          return (
            <Fragment key={randomBytes(6).toString("hex")}>
              {val}
              <br />
            </Fragment>
          )
        return <Fragment key={randomBytes(6).toString("hex")}>{val}</Fragment>
      }),
    [firstSlide]
  )

  const inputOnChange = e => {
    if (slide[0] !== 0 && slide[1] !== 0)
      setSlide([parseInt(e.target.value), 0])
    else setSlide([parseInt(e.target.value), slide[1]])
  }

  const contentOnChange = e => {
    if (slide[0] === 0) setSlide([1, parseInt(e.target.value)])
    else setSlide([slide[0], parseInt(e.target.value)])
  }

  return (
    <div className="process-slider">
      <input
        type="radio"
        name={`process-slide-${lang}`}
        id={`process-slide-${lang}-1`}
        checked={slide[0] === 0}
        value={0}
        onChange={inputOnChange}
      />
      <input
        type="radio"
        name={`process-slide-${lang}`}
        id={`process-slide-${lang}-2`}
        checked={slide[0] === 1}
        value={1}
        onChange={inputOnChange}
      />
      <div className="process-slides">
        <div className="process-inner">
          <div className="process-item">
            <section>
              <h1>{renderFirstSlide}</h1>
            </section>
            <section>
              {children}
              <label htmlFor={`process-slide-${lang}-2`}>
                <ProcessSlideNumbers currentSlideState={slide} lang={lang} />
              </label>
            </section>
          </div>
          <div className="process-item">
            <input
              type="radio"
              name="process-numbers"
              id={`process-number-${lang}-0`}
              value={0}
              onChange={contentOnChange}
              checked={slide[1] === 0}
            />
            <input
              type="radio"
              name="process-numbers"
              id={`process-number-${lang}-1`}
              value={1}
              onChange={contentOnChange}
              checked={slide[1] === 1}
            />
            <input
              type="radio"
              name="process-numbers"
              id={`process-number-${lang}-2`}
              value={2}
              onChange={contentOnChange}
              checked={slide[1] === 2}
            />
            <input
              type="radio"
              name="process-numbers"
              id={`process-number-${lang}-3`}
              value={3}
              onChange={contentOnChange}
              checked={slide[1] === 3}
            />
            <input
              type="radio"
              name="process-numbers"
              id={`process-number-${lang}-4`}
              value={4}
              onChange={contentOnChange}
              checked={slide[1] === 4}
            />
            <input
              type="radio"
              name="process-numbers"
              id={`process-number-${lang}-5`}
              value={5}
              onChange={contentOnChange}
              checked={slide[1] === 5}
            />
            <input
              type="radio"
              name="process-numbers"
              id={`process-number-${lang}-6`}
              value={6}
              onChange={contentOnChange}
              checked={slide[1] === 6}
            />
            <section>
              <ProcessSlideNumbers
                slide={slide}
                currentSlideState={slide}
                lang={lang}
              />
            </section>
            <section className="process-content">
              {children}
              <section className="process-content-inner">
                <article>
                  <h2>
                    {
                      content["slide1"].headings[
                        lang === "en" ? 0 : lang === "de" ? 1 : 2
                      ]
                    }
                  </h2>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: content["slide1"][lang],
                    }}
                  ></p>
                </article>
                <article>
                  <h2>
                    {
                      content["slide2"].headings[
                        lang === "en" ? 0 : lang === "de" ? 1 : 2
                      ]
                    }
                  </h2>
                  <p>{content["slide2"][lang]}</p>
                </article>
                <article>
                  <h2>
                    {
                      content["slide3"].headings[
                        lang === "en" ? 0 : lang === "de" ? 1 : 2
                      ]
                    }
                  </h2>
                  <p>{content["slide3"][lang]}</p>
                </article>
                <article>
                  <h2>
                    {
                      content["slide4"].headings[
                        lang === "en" ? 0 : lang === "de" ? 1 : 2
                      ]
                    }
                  </h2>
                  <p>{content["slide4"][lang]}</p>
                </article>
                <article>
                  <h2>
                    {
                      content["slide5"].headings[
                        lang === "en" ? 0 : lang === "de" ? 1 : 2
                      ]
                    }
                  </h2>
                  <p>{content["slide5"][lang]}</p>
                </article>
                <article>
                  <h2>
                    {
                      content["slide6"].headings[
                        lang === "en" ? 0 : lang === "de" ? 1 : 2
                      ]
                    }
                  </h2>
                  <p>{content["slide6"][lang]}</p>
                </article>
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

ProcessSlider.propTypes = {
  children: PropTypes.node,
  lang: PropTypes.string,
}

export default ProcessSlider
